module.exports = __webpack_public_path__ + "img/SMT_41_Mr_Keith_Lee_Wuan_Hong.ba8af7e2.jpg";